export default __webpack_public_path__ + "static/media/Gallery - Edition II vs IV - 2_01.b5a0535a.jpg";